export class Way {
  number: number;
  translationKey: string;
  value: string;

  constructor(value) {
    this.number = value === 'ONE' ? 1 : 2;
    this.translationKey = 'MEASURE_INPUT.WAY';
    this.value = value;
  }
}



// WEBPACK FOOTER //
// ./src/app/models/way.ts